class Menu {
    static CLOSE_DURATION = 250

    static EVENTS = {
        drawerOpen: 'drawer:open'
    }
    static SELECTORS = {
        menuDrawer: '#MenuDrawer',
        menuBtn: '[data-menu-toggle-btn]'
    }
    static CLASSES = {
        cartClosing: 'cart-closing',
        cartOpen: 'cart-open',
        menuClosing: 'menu-closing',
        menuOpening: 'menu-opening',
        menuOpen: 'menu-open',
        sidepanelClosing: 'sidepanel-closing',
        sidepanelOpening: 'sidepanel-opening',
        sidepanelOpen: 'sidepanel-open'
    }
    constructor() {
        this.isMenuPanelOpen = false
        this.closeTimeout = null

        this.elements = {
            body: document.body,
            menuDrawer: document.querySelector(Menu.SELECTORS.menuDrawer),
            menuBtn: document.querySelector(Menu.SELECTORS.menuBtn)
        }

        this.onClickOutsideDrawer = this.onClickOutsideDrawer.bind(this)
        this.onClickMenuButton = this.onClickMenuButton.bind(this)
        this.onDrawerOpen = this.onDrawerOpen.bind(this)
        this.bindEvents()
    }

    bindEvents() {
        if (!this.elements.menuBtn || !this.elements.menuDrawer) {
            return
        }

        this.elements.menuBtn.addEventListener('click', this.onClickMenuButton)
        document.addEventListener(Menu.EVENTS.drawerOpen, this.onDrawerOpen)
    }

    onClickMenuButton(event) {
        event.preventDefault()
        event.stopPropagation()
        this.toggleMenuDrawer()
    }

    onClickOutsideDrawer(event) {
        if (!this.elements.menuDrawer.contains(event.target)) {
            this.toggleMenuDrawer(false)
        }
    }

    onDrawerOpen(event) {
        if (event.detail.drawer !== 'menu' && this.isMenuPanelOpen) {
            this.toggleMenuDrawer(false)
        }
    }

    toggleMenuDrawer(force = null) {
        const isOpen = force === null ? !this.isMenuPanelOpen : force

        if (isOpen) {
            clearTimeout(this.closeTimeout)
            document.dispatchEvent(
                new CustomEvent(Menu.EVENTS.drawerOpen, {
                    detail: {
                        drawer: 'menu'
                    }
                })
            )
            this.elements.menuDrawer.focus()
            this.elements.body.classList.remove(
                Menu.CLASSES.sidepanelClosing,
                Menu.CLASSES.cartClosing,
                Menu.CLASSES.menuClosing
            )
            this.elements.body.classList.add(
                Menu.CLASSES.sidepanelOpening,
                Menu.CLASSES.menuOpening
            )
            void this.elements.menuDrawer.offsetHeight
            this.elements.body.classList.add(Menu.CLASSES.sidepanelOpen, Menu.CLASSES.menuOpen)
            this.elements.body.classList.remove(
                Menu.CLASSES.sidepanelOpening,
                Menu.CLASSES.menuOpening
            )
            document.addEventListener('click', this.onClickOutsideDrawer)
        } else {
            this.elements.menuBtn.focus()
            this.elements.body.classList.add(
                Menu.CLASSES.sidepanelClosing,
                Menu.CLASSES.menuClosing
            )
            this.elements.body.classList.remove(Menu.CLASSES.menuOpen)
            document.removeEventListener('click', this.onClickOutsideDrawer)
            this.closeTimeout = setTimeout(() => {
                this.elements.body.classList.remove(Menu.CLASSES.menuClosing)

                if (!this.elements.body.classList.contains(Menu.CLASSES.cartOpen)) {
                    this.elements.body.classList.remove(
                        Menu.CLASSES.sidepanelOpen,
                        Menu.CLASSES.sidepanelClosing,
                        Menu.CLASSES.sidepanelOpening,
                        Menu.CLASSES.menuOpening
                    )
                }
            }, Menu.CLOSE_DURATION)
        }

        this.elements.menuBtn.setAttribute('aria-expanded', String(isOpen))
        this.isMenuPanelOpen = isOpen
    }
}

document.addEventListener('DOMContentLoaded', () => new Menu())
